import { create } from "zustand";
import { ModelUploadService } from "../services/model-upload.service";
export const useModelUploadStateStore = create((set) => ({
    inProgress: false,
    type: ModelUploadService.FileType.invalid,
    setInProgress: (type) => {
        set({ inProgress: true, type: type });
    },
    setFinished: () => {
        set({ inProgress: false, type: ModelUploadService.FileType.invalid });
    }
}));
